module.exports = __webpack_public_path__ + "img/l.98861cea.jpg";